import { VerifyPhoneAttributes, CreateUserAttributes } from "../types";
import wretch, { WretcherError } from "wretch";

const API_BASE_URL =
  (import.meta.env.VITE_API_BASE_URL as string) || "http://localhost:3000";
const apiClient = wretch(API_BASE_URL).errorType("json");

export function sendVerifyCode(values: VerifyPhoneAttributes) {
  return apiClient
    .url(`/api/public/users.sendVerifyCode`)
    .post(values)
    .json()
    .catch((err: WretcherError) => {
      throw new Error(err?.json?.error?.detail || "Phone number rejected.");
    });
}

export function createUserFromCheckout(values: CreateUserAttributes) {
  return apiClient
    .url(`/api/public/users.createFromCheckout`)
    .post(values)
    .json();
}
